import React from 'react';

// Styles
import styles from "./../StaffManagment.module.css";

const StaffFinancialRequestCardDetail = (props) => {

    return (
        <>
            <div dir="rtl" className={`text-right mx-4 px-2 pt-2 pb-3 mt-2 mb-3`}>
                <div className={`d-flex align-items-start justify-content-between flex-wrap`}>
                    {
                        props.staffFinancialRequestData?.map(data => (
                            <div
                                key={data.id}
                                className={`w-100 text-right position-relative d-flex align-items-center justify-content-start flex-wrap mt-3 mb-2 p-3 ${styles.total_staff_support_card_box}`}
                            >
                                <img className={`${styles.image_staff_card_box}`} loading="lazy" src={`https://backdev.azrmelk.com/images/users/avatar/${data.userDto.avatarName}`} alt="user-profile" />

                                <div className={`d-flex align-items-center justify-content-start`}>
                                    <span className={`pe-4 mb-0 ${styles.title_staff_card_box}`}> {data.userDto.fullName} </span>
                                    {/* <span style={{ color: "#8D8D8D" }} className={`pe-2 mb-0 ${styles.subTitle_staff_card_box}`}> what </span> */}
                                </div>

                                <div className={`me-md-auto me-sm-0 d-flex align-items-center justify-content-start`}>
                                    <span style={{ color: "#8D8D8D" }} className={`pe-4 mb-0 ${styles.subTitle_staff_card_box}`}>
                                        {
                                            props.isRequestConsultant
                                                ? "مبلغ:"
                                                : props.isRequestAssistance
                                                    ? "مبلغ درخواستی:"
                                                    : ""
                                        }
                                    </span>
                                    <div>
                                        <span style={{ color: "#127442" }} className={`pe-2 mb-0 ${styles.title_staff_card_box}`}> {data.price?.toString()?.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,").replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])} </span>
                                        <span className={`mb-0 ${styles.currency_staff_card_box}`}> تومان </span>
                                    </div>
                                </div>

                                <div className={`me-md-auto me-sm-0 d-flex align-items-center justify-content-start`}>
                                    <span style={{ color: "#8D8D8D" }} className={`pe-4 mb-0 ${styles.subTitle_staff_card_box}`}> شماره کارت: </span>
                                    <span className={`pe-2 mb-0 ${styles.title_secondary_staff_card_box}`}> {data.cartNumber.replace(/(\d{4})(\d{4})(\d{4})(\d{4})/, "$1-$2-$3-$4")?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])} </span>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </>
    )
}

export default StaffFinancialRequestCardDetail;
